/**
 * Case-insensitive UUID comparison.
 * Both UUIDs are normalized to uppercase before comparison.
 *
 * @param uuid1 - First UUID to compare
 * @param uuid2 - Second UUID to compare
 * @returns true if both UUIDs are equal (case-insensitive), false otherwise
 */
export const compareUuids = (
  uuid1: string | null | undefined,
  uuid2: string | null | undefined
): boolean => {
  if (!uuid1 || !uuid2) return false;
  return uuid1.toUpperCase() === uuid2.toUpperCase();
};
